import http from '@/communication/AuthConnection'

export default async ({ state, commit }, payload) => {
  try {
    const result = await http.post(`/v1/quote/save-response`, payload)
    return result.data
  } catch (e) {
    return Promise.reject(e)
  }
}



// WEBPACK FOOTER //
// ./src/brain/quote/save-quotation-response/index.js